import * as React from 'react';

import { cn } from '../lib';

export interface InputProps
  extends React.InputHTMLAttributes<HTMLInputElement> {}

const Input = React.forwardRef<HTMLInputElement, InputProps>(
  ({ className, type, disabled, ...props }, ref) => {
    return (
      <input
        type={type}
        disabled={disabled}
        className={cn(
          'flex',
          'h-10',
          'w-full',
          'rounded-md',
          'border',
          disabled ? 'border-gray-70' : 'border-input',
          'bg-background',
          'px-3',
          'py-2',
          'text-sm',
          'ring-offset-background',
          'file:border-0',
          'file:bg-transparent',
          'file:text-sm',
          'file:font-medium',
          'placeholder:text-placeholder',
          'focus-visible:outline-none',
          'focus-visible:ring-2',
          'focus-visible:ring-ring',
          'focus-visible:ring-offset-2',
          'disabled:cursor-not-allowed',
          'disabled:text-gray-600',
          'disabled:bg-gray-50',
          className
        )}
        ref={ref}
        {...props}
      />
    );
  }
);
Input.displayName = 'Input';

export { Input };
